import { initDatatable } from "./datatable_factory";
import { interpolate } from "../utils/string_utils";

const PAYSLIPS_DATATABLE_ID = "payslips-datatable";

const initPayslipsDatatable = () => {
  const datatableElement = document.getElementById(PAYSLIPS_DATATABLE_ID);
  const payload = {
    datatableElement: datatableElement,
    orderColumns: [[0, "desc"]],
    columns: datatableColumns(),
  };
  initDatatable(payload);
};

const columnNames = {
  period: "period",
  file: "file",
};

const datatableColumns = () => {
  return [
    { data: columnNames.period },
    {
      data: columnNames.file,
      searchable: false,
      orderable: false,
      render: (data) =>
        interpolate(document.getElementById("payslip-file-column-template"), {
          file_name: data.name,
          file_url: data.url,
        }),
    },
  ];
};

export { initPayslipsDatatable };
